<template>
  <v-row>
    <v-col cols="12" class="d-flex flex-wrap">
      <div
        v-if="statePhotos.front"
        class="col-xl-2 col-md-3 col-sm-6 cols-12"
      >
        <div class="img-uploader">
          <image-uploader-new
          :photo.sync="statePhotos.front"
          :label="`${$t('auto.photo.front')}`"
          readonly
          outlined
        />
        </div>
      </div>
      <div
        v-if="statePhotos.rear"
        class="col-xl-2 col-md-3 col-sm-6 cols-12"
      >
        <div class="img-uploader">
          <image-uploader-new
            :photo.sync="statePhotos.rear"
            :label="`${$t('auto.photo.back')}`"
            class="img-uploader"
            readonly
            outlined
          />
        </div>
      </div>
      <div
        v-if="statePhotos.frontLeft"
        class="col-xl-2 col-md-3 col-sm-6 cols-12"
      >
        <div class="img-uploader">
          <image-uploader-new
            :photo.sync="statePhotos.frontLeft"
            :label="`${$t('auto.photo.left')}`"
            class="img-uploader"
            readonly
            outlined
          />
        </div>
      </div>
      <div
        v-if="statePhotos.frontRight"
        class="col-xl-2 col-md-3 col-sm-6 cols-12"
      >
        <div class="img-uploader">
          <image-uploader-new
            :photo.sync="statePhotos.frontRight"
            :label="`${$t('auto.photo.right')}`"
            class="img-uploader"
            readonly
            outlined
          />
        </div>
      </div>
      <div
        v-if="statePhotos.interiorDashboard"
        class="col-xl-2 col-md-3 col-sm-6 cols-12"
      >
        <div class="img-uploader">
          <image-uploader-new
            :photo.sync="statePhotos.interiorDashboard"
            :label="`${$t('auto.photo.console')}`"
            class="img-uploader"
            readonly
            outlined
          />
        </div>
      </div>
      <div
        v-if="statePhotos.frontLeftWheel"
        class="col-xl-2 col-md-3 col-sm-6 cols-12"
      >
        <div class="img-uploader">
          <image-uploader-new
            :photo.sync="statePhotos.frontLeftWheel"
            :label="`${$t('auto.photo.frontLeftWheel')}`"
            class="img-uploader"
            readonly
            outlined
          />
        </div>
      </div>
      <div
        v-if="statePhotos.rearLeftWheel"
        class="col-xl-2 col-md-3 col-sm-6 cols-12"
      >
        <div class="img-uploader">
          <image-uploader-new
            :photo.sync="statePhotos.rearLeftWheel"
            :label="`${$t('auto.photo.backLeftWheel')}`"
            class="img-uploader"
            readonly
            outlined
          />
        </div>
      </div>
      <div
        v-if="statePhotos.frontRightWheel"
        class="col-xl-2 col-md-3 col-sm-6 cols-12"
      >
        <div class="img-uploader">
          <image-uploader-new
            :photo.sync="statePhotos.frontRightWheel"
            :label="`${$t('auto.photo.frontRightWheel')}`"
            class="img-uploader"
            readonly
            outlined
          />
        </div>
      </div>
      <div
        v-if="statePhotos.rearRightWheel"
        class="col-xl-2 col-md-3 col-sm-6 cols-12"
      >
        <div class="img-uploader">
          <image-uploader-new
            :photo.sync="statePhotos.rearRightWheel"
            :label="`${$t('auto.photo.backRightWheel')}`"
            class="img-uploader"
            readonly
            outlined
          />
        </div>
      </div>
      <div
        v-if="statePhotos.trunk"
        class="col-xl-2 col-md-3 col-sm-6 cols-12"
      >
        <div class="img-uploader">
          <image-uploader-new
            :photo.sync="statePhotos.trunk"
            :label="`${$t('auto.photo.trunk')}`"
            class="img-uploader"
            readonly
            outlined
          />
        </div>
      </div>
      <div
        v-if="statePhotos.bonnet"
        class="col-xl-2 col-md-3 col-sm-6 cols-12"
      >
        <div class="img-uploader">
          <image-uploader-new
            :photo.sync="statePhotos.bonnet"
            :label="`${$t('auto.photo.hood')}`"
            class="img-uploader"
            readonly
            outlined
          />
        </div>
      </div>
      <div
        v-if="statePhotos.interiorBack"
        class="col-xl-2 col-md-3 col-sm-6 cols-12"
      >
        <div class="img-uploader">
          <image-uploader-new
            :photo.sync="statePhotos.interiorBack"
            :label="`${$t('auto.photo.interiorBack')}`"
            class="img-uploader"
            readonly
            outlined
          />
        </div>
      </div>
      <div
        v-if="statePhotos.interiorFront"
        class="col-xl-2 col-md-3 col-sm-6 cols-12"
      >
        <div class="img-uploader">
          <image-uploader-new
            :photo.sync="statePhotos.interiorFront"
            :label="`${$t('auto.photo.interiorFront')}`"
            class="img-uploader"
            readonly
            outlined
          />
        </div>
      </div>
      <div
        v-if="statePhotos.torpedo"
        class="col-xl-2 col-md-3 col-sm-6 cols-12"
      >
        <div class="img-uploader">
          <image-uploader-new
            :photo.sync="statePhotos.torpedo"
            :label="`${$t('auto.photo.interiorTorpedo')}`"
            class="img-uploader"
            readonly
            outlined
          />
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import ImageUploaderNew from '@/components/shared/ImageUploader.vue';

export default {
  data: () => ({

  }),
  components: {
    ImageUploaderNew,
  },
  props: {
    statePhotos: Object,
  },
};
</script>

<style lang="scss" scoped>
.img-uploader {
  height: 220px;
}
</style>
